import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useCookies } from "react-cookie";
import { Link } from "react-router-dom";

const UpdateTeam = () => {
  const [name, setName] = useState('');
  const [position, setPosition] = useState('');
  const [paragraph, setParagraph] = useState('');
  const [fileName, setFileName] = useState('');
  const [image, setImage] = useState(null);
  const [cookies] = useCookies(['editedTeam']);

  useEffect(() => {
    if (cookies.editedTeam) {
      const { name, position, paragraph, image } = cookies.editedTeam;
      setName(name);
      setPosition(position);
      setParagraph(paragraph);
      setFileName(image ? image.split('/').pop() : '');
    }
  }, [cookies.editedTeam]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    setFileName(file.name);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const formData = new FormData();
      formData.append('name', name);
      formData.append('position', position);
      formData.append('paragraph', paragraph);
      
    
      const token = localStorage.getItem('token');
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      console.log(`Id is ${cookies.editedTeam._id}`)
  
      if (image) {
        formData.append('image', image);
      }
      // Replace with your backend API endpoint
      const apiUrl = `https://api.mbasolutions.co/api/team/${cookies.editedTeam._id}`;
      await axios.put(apiUrl,formData,config);
  
      Swal.fire({
        icon: 'success',
        title: 'Team member updated successfully!',
        showConfirmButton: false,
        timer: 1500,
      });
        window.location = "/admindashboard";
    } catch (error) {
      console.error('Error updating team member:', error);
    
      // Log complete error object
      console.error('Complete error object:', error.response);
    
      Swal.fire({
        icon: 'error',
        title: 'Error updating team member',
        text: 'Please try again.',
      });
    }
  }
    

  return (
    <>
      <div className="mx-3 md:mx-10">
        <form
          onSubmit={handleSubmit}
          className="w-full flex flex-col justify-center"
        >
          <div className="mx-auto">
            <label
              htmlFor="name"
              className="block text-[20px] py-4 font-semibold"
            >
              {" "}
              Name
            </label>
            <input
              name="name"
              id="name"
              onChange={(e) => setName(e.target.value)}
              value={name}
              className="rounded-md h-12 px-1 md:w-[570px] border hover:outline-purple-500"
            />
          </div>
          <div className="mx-auto">
            <label
              htmlFor="position"
              className="block  text-[20px] py-4 font-semibold"
            >
              {" "}
              Position
            </label>
            <input
              name="position"
              id="position"
              onChange={(e) => setPosition(e.target.value)}
              value={position}
              className="rounded-md h-12 px-1 md:w-[570px] border hover:outline-purple-500"
            />
          </div>
          <div className="mx-auto">
            <label
              htmlFor="paragraph"
              className="block text-[20px] text-center md:text-left pt-5 py-4 font-semibold"
            >
              About the Personality(5 to 6 words):
            </label>
            <textarea
              name="paragraph"
              id="paragraph"
              onChange={(e) => setParagraph(e.target.value)}
              value={paragraph}
              className="md:w-[570px] h-32 px-1 ml-4 md:ml-0 w-[270px] rounded-md  border hover:outline-purple-500"
            />
          </div>
          <div className="mx-auto md:w-[570px] mt-12">
            <label
              htmlFor="image"
              className="block text-[20px] py-4 font-semibold"
            >
              Choose Image:
            </label>

            <input
              type="file"
              name="image"
              id="image"
              onChange={handleImageChange}
              className="  outline-none h-10 m-2  text-md text-center "
            />
            <br />
            {fileName}
          </div>
          <div>
           
            <button
              type="submit"
              className="block text-[20px] p-2 my-4 bg-purple-500 text-white hover:bg-purple-700 rounded-md mx-auto  "
            >
              Update Data
            </button>
            
          </div>
        </form>
      </div>
    </>
  );
};

export default UpdateTeam;
